export default __webpack_public_path__ + "static/media/dog3.8c4c61bd.jpg";